import { ColumnModel } from "@syncfusion/ej2-react-grids";
import { GridColumn } from "@syncfusion/ej2-react-grids";
import { BaseGridColumnModel } from "../../GridColumnTemplates/types";
import { GridHtmlColumnTemplate } from "../../GridColumnTemplates/GridHtmlColumnTemplate";

interface GridHtmlColumnOptions extends ColumnModel {}

export default class GridHtmlColumn extends GridColumn {
  constructor(opts: GridHtmlColumnOptions) {
    const { ...superOpts } = opts;
    super({
      ...superOpts,
      template: ((model: Record<string, string>) => {
        return GridHtmlColumnTemplate(
          this satisfies BaseGridColumnModel,
          model
        );
      }) as any,
    });
  }
}
